module.exports = __webpack_public_path__ + "2a5c0b13.woff";